import type { AdAccountId, Anchor, MetaObjectId } from "@nabla/contract";
import type { Place, Ref } from "./common.ts";

export function hrefOf(place: Place, id: string): string {
  return place === "empresa" ? "/" : `/${place}/${id}`;
}

export function anchorOf(ref: Ref): Anchor | undefined {
  if (ref.place === "conversa") return undefined;
  const { name: _name, href: _href, ...anchor } = ref;
  return anchor;
}

type ManagerTarget =
  | { readonly place: "conta"; readonly account: AdAccountId }
  | { readonly place: "campanha" | "conjunto" | "anuncio"; readonly account: AdAccountId; readonly id: MetaObjectId };

const tabs = { campanha: ["campaigns", "campaign"], conjunto: ["adsets", "adset"], anuncio: ["ads", "ad"] } as const;

export function adsManagerUrl(target: ManagerTarget): string {
  const act = target.account.slice("act_".length);
  if (target.place === "conta") return `https://adsmanager.facebook.com/adsmanager/manage/campaigns?act=${act}`;
  const [tab, selected] = tabs[target.place];
  return `https://adsmanager.facebook.com/adsmanager/manage/${tab}?act=${act}&selected_${selected}_ids=${target.id}`;
}

export function localPath(given: string | null, origin: string): string {
  if (given === null || given.length > 512 || !given.startsWith("/") || given.includes("\\")) return "/";
  try {
    if (/[\u0000-\u001f\u007f-\u009f]/u.test(decodeURIComponent(given))) return "/";
    const url = new URL(given, origin);
    if (url.origin !== new URL(origin).origin || url.pathname.startsWith("//")) return "/";
    return `${url.pathname}${url.search}`;
  } catch {
    return "/";
  }
}
